<script setup>
import { vInline } from "~/composables/useInlineEdit";

defineProps({ data: { type: Object, required: true } });
</script>

<template>
  <section class="relative overflow-hidden">
    <!-- Decorative blobs (echo logo arcs) -->
    <div
      aria-hidden="true"
      class="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-brand-green/15 blur-3xl"
    />
    <div
      aria-hidden="true"
      class="pointer-events-none absolute -bottom-40 -right-32 h-[28rem] w-[28rem] rounded-full bg-brand-orange/20 blur-3xl"
    />

    <div class="container-x relative py-16 sm:py-20 md:py-28 lg:py-32">
      <div class="grid items-center gap-8 md:gap-12 lg:grid-cols-[1.1fr_0.9fr]">
        <div class="space-y-6 max-w-2xl">
          <div class="rainbow-rule" />
          <h1 class="font-display">
            <span class="block" v-inline="'title'">{{ data.title }}</span>
          </h1>
          <p v-if="data.subtitle" class="text-lg md:text-xl text-muted leading-relaxed" v-inline="'subtitle'">
            {{ data.subtitle }}
          </p>
          <div v-if="data.cta" class="pt-2">
            <NuxtLink :to="data.cta.url" class="btn-primary no-underline">
              {{ data.cta.label }}
              <svg class="h-4 w-4" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </NuxtLink>
          </div>
        </div>

        <div v-if="data.image" class="relative">
          <!-- Decorative rotated frame behind hero image -->
          <div
            aria-hidden="true"
            class="absolute inset-0 rounded-[1.125rem] bg-rainbow-line rotate-[-2deg] opacity-90"
          />
          <img
            :src="data.image.url"
            :alt="data.image.alt_text || data.title"
            loading="eager"
            class="relative aspect-[4/3] w-full rounded-[0.875rem] object-cover shadow-soft"
          />
        </div>
      </div>
    </div>
  </section>
</template>
